import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { MdSchedule } from 'react-icons/md';
import CronJobEditor from 'Utils/CronJobEditor';
import { DataSourceContext } from './Utils';

function SchedulePanel () {
  const { connection, setConnection } = useContext(DataSourceContext);

  return (
    <Card className="shadow-sm widget-card">
      <div className="d-flex flex-row p-2">
        <MdSchedule className='mr-2' />
        Automated Discoveries
      </div>
      <Card.Body>
      <CronJobEditor
        scheduleEnabled={connection.scheduleEnabled}
        scheduleDayOfWeek={connection.scheduleDayOfWeek}
        scheduleWeekOccurrence={connection.scheduleWeekOccurrence}
        scheduleHour={connection.scheduleHour}
        scheduleMinute={connection.scheduleMinute}
        scheduleRules={connection.scheduleRules}
        setScheduleData={(v) => {
          setConnection({
            ...connection,
            scheduleEnabled: v.scheduleEnabled,
            scheduleDayOfWeek: v.scheduleDayOfWeek,
            scheduleWeekOccurrence: v.scheduleWeekOccurrence,
            scheduleHour: v.scheduleHour,
            scheduleMinute: v.scheduleMinute,
            scheduleRules: v.scheduleRules
          })
        }}
      />
      </Card.Body>
    </Card>
  );
}

export default SchedulePanel;
